import React, { useCallback, useEffect, useRef } from 'react';
import * as S from './SortDropdown.styles';

interface SortDropdownProps {
  isOpen: boolean;
  onClose: () => void;
}

// Can be removed if appropriate component is created inside shared UI folder
export const SortDropdown = ({
  isOpen,
  onClose,
  children,
}: React.PropsWithChildren<SortDropdownProps>) => {
  const dropdownRef = useRef<HTMLDivElement>(null);

  const handleClickOutside = useCallback(
    (event: MouseEvent) => {
      const target = event.target as Node;
      const dropdown = dropdownRef?.current;
      const parent = dropdown?.parentElement;

      if (!dropdown?.contains(target) && !parent?.contains(target)) {
        event.stopPropagation();
        onClose();
      }
    },
    [onClose]
  );

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
  };

  useEffect(() => {
    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen, handleClickOutside]);

  if (!isOpen) return null;

  return (
    <S.Dropdown ref={dropdownRef} $isOpen={isOpen} onClick={handleClick}>
      {children}
    </S.Dropdown>
  );
};
